// 画面外カードの Stimulus コントローラ初期化を遅延する。
// data-controller-deferred に退避した正規の識別子文字列を、ビューポート接近時に
// そのまま data-controller へコピーして Stimulus に hydrate させる。
// 文字列は entrypoint ごとの require.context ルート差異の影響を受けないよう、再構成せず verbatim にコピーする。

const DEFERRED_ATTR = 'data-controller-deferred'
// カードが視認・タップ可能になる前に hydrate するためのバッファ。
// これにより画面外カードの heart 取りこぼし・お気に入り済み表示・Cookieバイパスの反映遅れを実質的に解消する。
const ROOT_MARGIN = '600px 0px'

function hydrate (element) {
  const controller = element.getAttribute(DEFERRED_ATTR)
  if (!controller) return

  element.removeAttribute(DEFERRED_ATTR)
  element.setAttribute('data-controller', controller)
}

function start () {
  const deferred = document.querySelectorAll(`[${DEFERRED_ATTR}]`)
  if (deferred.length === 0) return

  if (typeof IntersectionObserver !== 'function') {
    deferred.forEach(hydrate)
    return
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      obs.unobserve(entry.target)
      hydrate(entry.target)
    })
  }, { rootMargin: ROOT_MARGIN })

  deferred.forEach((element) => observer.observe(element))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start)
} else {
  start()
}
